<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import Aws from "@/services/Aws";

export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "AWS Applications",
            error: null,
            tableData: [],
            currentPage: 1,
            perPage: 10,
            items: [
                {
                    text: "AWS",
                },
                {
                    text: "AWS Applications",
                    active: true,
                },
            ] ,
            pageOptions: [10, 25],
            filter: null,
            filterOn: [],
            sortBy: "name",
            sortDesc: false,
            isBusy: false,
            roles : [],
            fields: [
                {
                    key: "name",
                    label: "Name",
                    sortable: true,
                },
                {
                    key: "resources",
                    label: "Resources",
                    sortable: false,
                },
                {
                    key: "note",
                    label: "Note",
                    sortable: false,
                },
                "action",
            ],
            totalRows: 0,
            showModal: false
        };
    },
    async mounted() {
        await this.getApplications()
    },
    methods: {
        async getApplications() {
            try {
                this.isBusy = true;
                const response = await Aws.getApplications();
                this.originalTableData = response.data.data;
                this.tableData = [...this.originalTableData];
                this.totalRows = this.tableData.length;
            } catch (error) {
                this.error = error.response.data.error ? error.response.data.error : "";
                this.tableData = [];
                this.totalRows = 0;
            } finally {
                this.showLoader = false;
                this.isBusy = false;
            }
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },


    },
    middleware: "authentication",
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">Total Applications: {{totalRows}}</h4>
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-3">
                                <div class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>


                            <!-- Search -->
                            <div class="col-sm-12 col-md-9">
                                <div
                                        id="tickets-table_filter"
                                        class="dataTables_filter text-md-end"
                                >
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    :busy="isBusy"
                                    :items="tableData"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    show-empty
                                    empty-text="No Data Found"
                                    @filtered="onFiltered"
                            >

                              <template v-slot:cell(name)="data">
                                <router-link title="View Application Details" :to="{ path: `/aws/applications/${data.item.id}` }">
                                  {{data.item.name}}
                                </router-link>
                              </template>

                              <template v-slot:cell(resources)="data">
                                    <div class="row text-nowrap">
                                        <div class="col-sm-12 col-md-6 p-0">
                                             <span v-for="(resource, index) in data.item.resources" :key="index">
                                                <p class="mb-0">
                                                    <span v-if="resource.resource_type == 'loadbalancers'">
                                                        Load Balancer: <span
                                                            class="text-strong">{{resource.LoadBalancerName}}</span>
                                                    </span>
                                                     <span v-if="resource.resource_type == 'targetgroups'">
                                                         Target Group: <span
                                                             class="text-strong">{{resource.TargetGroupName}}</span>
                                                     </span>
                                                     <span v-if="resource.resource_type == 'rds_cluster'">
                                                         RDS Cluster: <span class="text-strong">{{resource.resource_id}}</span>
                                                    </span>
                                                </p>
                                             </span>
                                        </div>
                                        <div class="col-sm-12 col-md-6 p-0">
                                            <p class="mb-0">
                                                <span>RDS Readers: <span class="text-strong">{{data.item.rdsReaderInstancesCount}}</span></span>
                                            </p>
                                            <p class="mb-0">
                                                <span>RDS Writers: <span class="text-strong">{{data.item.rdsWriterInstancesCount}}</span></span>
                                            </p>
                                            <p class="mb-0">
                                                <span>Target Group Instances: <span class="text-strong">{{data.item.tgInstancesCount}}</span></span>
                                            </p>
                                        </div>
                                    </div>

                                </template>

                                <template v-slot:cell(action)="data">
                                    <ul class="list-inline mb-0">
                                        <li class="list-inline-item">
                                            <router-link title="View Application Details" :to="{ path: `/aws/applications/${data.item.id}` }">
                                                <i class="uil uil-eye font-size-18"></i>
                                            </router-link>
                                        </li>
                                    </ul>
                                </template>

                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>

                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="totalRows"
                                                :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>
